module.exports = __webpack_public_path__ + "img/paid_stamp.2831fca1.png";